// Chrome co.: one fixed 3D scene behind the whole page
(function(){
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
var h=document.querySelector('.hero-copy h1');
if(h&&!reduce){var t=h.textContent,ch='01#%&@*+=',f=0;h.setAttribute('aria-label',t);
var iv=setInterval(function(){f++;h.textContent=t.split('').map(function(c,i){return i<f/2||c===' '?c:ch[Math.random()*ch.length|0]}).join('');if(f/2>=t.length){h.textContent=t;clearInterval(iv)}},40)}
var c=document.getElementById('scene');if(!c||!window.THREE)return;
var R;try{R=new THREE.WebGLRenderer({canvas:c,antialias:true,alpha:true})}catch(e){c.remove();return}
R.toneMapping=THREE.ACESFilmicToneMapping;R.toneMappingExposure=1.1;
var S=new THREE.Scene(),cam=new THREE.PerspectiveCamera(40,1,.1,100);cam.position.z=7;
var E=new THREE.Scene();E.add(new THREE.Mesh(new THREE.BoxGeometry(20,20,20),new THREE.MeshBasicMaterial({color:0x050505,side:THREE.BackSide})));
[[0,8,0,12,.4,6],[-9,0,2,.4,9,6],[9,1,-2,.4,6,3],[0,-8,0,8,.4,4]].forEach(function(a){
var m=new THREE.Mesh(new THREE.BoxGeometry(a[3],a[4],a[5]),new THREE.MeshBasicMaterial({color:new THREE.Color(6,6,6)}));m.position.set(a[0],a[1],a[2]);E.add(m)});
S.environment=new THREE.PMREMGenerator(R).fromScene(E,.02).texture;
var knot=new THREE.Mesh(new THREE.TorusKnotGeometry(1.1,.38,220,32,2,3),new THREE.MeshStandardMaterial({color:0xffffff,metalness:1,roughness:.08}));S.add(knot);
var N=500,P=new Float32Array(N*3),i;for(i=0;i<N;i++){P[i*3]=Math.random()*16-8;P[i*3+1]=Math.random()*10-5;P[i*3+2]=Math.random()*6-4}
var g=new THREE.BufferGeometry();g.setAttribute('position',new THREE.BufferAttribute(P,3));
S.add(new THREE.Points(g,new THREE.PointsMaterial({size:.035,color:0xffffff,transparent:true,opacity:.6})));
var mx=0,my=0,sp=0,px=0,py=0,W=1;
addEventListener('mousemove',function(e){mx=e.clientX/innerWidth*2-1;my=-(e.clientY/innerHeight*2-1)});
function size(){R.setPixelRatio(Math.min(devicePixelRatio,2));R.setSize(innerWidth,innerHeight,false);cam.aspect=innerWidth/innerHeight;cam.updateProjectionMatrix();W=innerWidth<800}
addEventListener('resize',function(){size();if(reduce)R.render(S,cam)});size();
function frame(time){
var max=document.documentElement.scrollHeight-innerHeight,p=max>0?scrollY/max:0,s=time*.001;
var tx=W?0:1.7*Math.cos(p*Math.PI*2.5),ty=W?1.3-p*1.5:0;
px+=(tx-px)*.06;py+=(ty-py)*.06;sp+=(p-sp)*.08;
knot.position.set(px,py,0);knot.scale.setScalar(W?.7:1);
knot.rotation.y=sp*12+(reduce?0:s*.25)+mx*.4;knot.rotation.x=sp*4+my*.3;
if(!reduce){var hh=2.55,ww=hh*cam.aspect,cx=mx*ww,cy=my*hh;
for(var k=0;k<N;k++){var j=k*3;P[j+1]+=.004;if(P[j+1]>5)P[j+1]=-5;
var dx=P[j]-cx,dy=P[j+1]-cy,d=dx*dx+dy*dy;if(d<1.4){var f=.04/(Math.sqrt(d)+.1);P[j]+=dx*f;P[j+1]+=dy*f}}
g.attributes.position.needsUpdate=true}
R.render(S,cam);if(!reduce)requestAnimationFrame(frame)}
if(reduce){frame(0);addEventListener('scroll',function(){frame(0)})}else requestAnimationFrame(frame);
})();
